<template>
  <v-chip
    size="small"
    :color="ACCOUNT_COLORS[accountType]"
    class="font-weight-bold"
  >
    {{ $t(`accountTypes.${accountType}`) }}
  </v-chip>
</template>

<script setup lang="ts">
import { ACCOUNT_COLORS } from "@/lib/colors";

interface Props {
  accountType: string;
}

defineProps<Props>();
</script>
